export const NDR_SHIPMENT_SUCCESS = "NDR_SHIPMENT_SUCCESS";
export const NDR_SHIPMENT_REQUEST = "NDR_SHIPMENT_REQUEST";
export const NDR_SHIPMENT_FAILURE = "NDR_SHIPMENT_FAILURE";
export const NDR_SHIPMENT_RESET = "NDR_SHIPMENT_RESET";
export const ndrShipmentSuccess = (payload) => ({
    type: NDR_SHIPMENT_SUCCESS,
    payload,
});
export const ndrShipmentRequest = (payload) => ({
    type: NDR_SHIPMENT_REQUEST,
    payload,
});
export const ndrShipmentFailure = (payload) => ({
    type: NDR_SHIPMENT_FAILURE,
    payload,
});
export const ndrShipmentReset = () => ({
    type: NDR_SHIPMENT_RESET,
});
